import { render } from "./IconSignature.vue?vue&type=template&id=342ed772"
const script = {}
script.render = render

export default script